import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { UserDetailsApiResponse } from '../types/user/types'


type UserStore = {
    user: UserDetailsApiResponse | null
    setUser: (user: UserDetailsApiResponse) => void
    clearUser: () => void
}

export const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            user: null,
            setUser: (user) => set({ user }),
            clearUser: () => set({ user: null }),
        }),
        { name: 'user-storage' }
    )
)